import type { ComponentProps } from 'react';
import type ReactEChartsCore from 'echarts-for-react/lib/core';

type EChartsInitOptions = NonNullable<ComponentProps<typeof ReactEChartsCore>['opts']> & {
  useCoarsePointer?: boolean;
  pointerSize?: number;
};

/** A larger hit area makes lines and symbols reachable on touch and coarse pointers. */
export const CHART_INIT_OPTIONS: EChartsInitOptions = {
  useCoarsePointer: true,
  pointerSize: 36,
};
